import React, { useContext } from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import moment from 'moment';
// ICONS
import { Upload, CheckCircleOutline, ImportExport } from '@mui/icons-material';
// CONTEXT
import useAllocationContext from '../context/useAllocationContext';
export default function Header() {
  const { plan, inventory, handleImportModal, handleExportTemplate, handleFinalizeAllocation } =
    useContext(useAllocationContext);

  const STATUS_FINALIZED = 5;

  const handleStatusStyle = (value) => {
    switch (value) {
      case 1:
        return {
          color: 'default',
          sx: {},
        };

      case 2:
        return {
          color: 'warning',
          sx: {},
        };

      case 3:
        return {
          color: undefined,
          sx: {
            backgroundColor: '#FFDE21',
            color: '#000',
          },
        };

      case 4:
      case 5:
        return {
          color: 'success',
          sx: {},
        };

      default:
        return {
          color: 'default',
          sx: {},
        };
    }
  };

  return (
    <Box mb={3}>
      <Typography variant='body2' color='text.secondary'>
        {plan.title} / {plan?.plan_id} / Allocation
      </Typography>

      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='flex-start'
        flexWrap='wrap'
        gap={2}
      >
        <Box>
          <Typography variant='h4' fontWeight={700}>
            {plan.title}
          </Typography>

          <Box mt={1}>
            <Chip
              size='small'
              label={plan.status}
              color={handleStatusStyle(plan?.status_id)?.color}
              sx={handleStatusStyle(plan?.status_id)?.sx}
            />

            <Chip
              size='small'
              color={plan.category === 'Regular' ? 'success' : 'warning'}
              label={`${plan.category}${
                plan.sub_category ? ` - ${plan.sub_category}` : ''
              } Sampling`}
              sx={{ marginLeft: '5px' }}
            />
          </Box>

          <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
            {plan?.plan_id} • Created: {moment(plan?.created_at).format('MMM YYYY')} • Effectivity:{' '}
            {plan.effectivity_month} {plan.effectivity_year} • Owner {plan?.owner}
          </Typography>
        </Box>

        {plan.status_id !== STATUS_FINALIZED && (
          <Box sx={{ display: 'flex', gap: 2, alignSelf: 'flex-start' }}>
            <Button
              variant='contained'
              color='warning'
              startIcon={<Upload />}
              onClick={handleImportModal}
            >
              Import Allocation
            </Button>
            <Button
              variant='contained'
              color='primary'
              startIcon={<ImportExport />}
              onClick={handleExportTemplate}
            >
              Export Template
            </Button>
            <Button
              variant='contained'
              color='success'
              disabled={Boolean(inventory?.items?.some((row) => Number(row.allocated_qty) === 0))}
              startIcon={<CheckCircleOutline />}
              onClick={handleFinalizeAllocation}
            >
              FINALIZE ALLOCATION
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
